import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "61px",
        cursor: "pointer",
    },
    img: {
        margin: "5px 10px 0 0",
    },
    title: {
        color: " #353535",
        fontSize: "16px",
        letterSpacing: 0,
    },
}));

export default useStyles;
